export const styles = {
  default: {
    mobilePaddingTop: 92,
    desktopPaddingTop: 140,
    mobileNoNavPaddingTop: 44,
    desktopNoNavPaddingTop: 92
  },
  ballybetca: {
    mobilePaddingTop: 88,
    desktopPaddingTop: 136,
    mobileNoNavPaddingTop: 44,
    desktopNoNavPaddingTop: 92
  },
  ballybetaz: {
    mobilePaddingTop: 152,
    desktopPaddingTop: 118,
    mobileNoNavPaddingTop: 100,
    desktopNoNavPaddingTop: 66
  }
}
